
export default {
    name: "GcuLink",
    data() {
        return {};
    },
    computed: {
        link() {
            return (
                "https://ar-go.co/" + this.$i18n.locale + "/stqr-conditions-generales-dutilisation/"
            );
        }
    }
};
